import type VueI18n from 'vue-i18n'
import _ from 'lodash'
import { AxiosError } from 'axios'
import { IErrorData } from '../service/types'

const CASE_TIME_ERROR = '$$CASE_TIME_ERROR'

export class CaseTimeAxiosError extends Error {
    tag = CASE_TIME_ERROR
    numeric_error_code: number|undefined
    constructor(public i18n: VueI18n,
        public detail?: AxiosError<IErrorData>) {
        super(_.get(detail, 'message', 'CaseTimeError'))
        this.numeric_error_code = this.detail?.response?.data.numeric_error_code
    }
}

export function isCaseTimeAxiosError(e): e is CaseTimeAxiosError {
    return e && e.tag === CASE_TIME_ERROR
}
